import { COLOURS } from '../styles';

export const datetimeFormats = {
  long: 'dd/MM/yyyy HH:mm:ss',
  short: 'd/M H:mm',
  powerDaily: 'd/M',
  picker: 'dd/MM/yyyy',
  filename: 'yyMMdd',
  filename_long: 'yyMMdd_HH:mm',
  mid: 'dd/MMM/yyyy HH:mm',
};

export const FILTER_OPTIONS = {
  statusGroup: 1,
  statusDeviceOffline: 2,
  statusDeviceInFault: 3,
  statusDeviceGood: 4,
  statusDeviceUnknown: 5,

  statusDeviceFaultsAny: 6,
  statusDeviceFaultsInternalCommsIssue: 7,
  statusDeviceFaultsTherm1ShortCircuit: 8,
  statusDeviceFaultsTherm1OpenCircuit: 9,
  statusDeviceFaultsTherm2ShortCircuit: 10,
  statusDeviceFaultsTherm2OpenCircuit: 11,
  statusDeviceFaultsPumpCommunicationsFault: 12,
  statusDeviceFaultsExpansion1Fault: 13,
  statusDeviceFaultsExpansion2Fault: 14,
  statusDeviceFaultsAmbientTemperatureFault: 15,
  statusDeviceFaultsPhOrpExpansionFault: 16,
  statusDeviceFaultsTherm3ShortCircuit: 17,
  statusDeviceFaultsTherm3OpenCircuit: 18,
  statusDeviceFaultsCRCError: 19,
  statusDeviceFaultsCRC2Error: 20,
  statusDeviceFaultsUnused15: 21,
  statusDeviceFaultsUnused16: 22,
  statusDeviceFaultsUnused17: 23,
  statusDeviceFaultsUnused18: 24,
  statusDeviceFaultsUnused19: 25,
  statusDeviceFaultsUnused20: 26,
  statusDeviceFaultsUnused21: 27,
  statusDeviceFaultsUnused22: 28,
  statusDeviceFaultsUnused23: 29,
  statusDeviceFaultsUnused24: 30,
  statusDeviceFaultsUnused25: 31,
  statusDeviceFaultsUnused26: 32,
  statusDeviceFaultsUnused27: 33,
  statusDeviceFaultsUnused28: 34,
  statusDeviceFaultsUnused29: 35,
  statusDeviceFaultsUnused30: 36,
  statusDeviceFaultsUnused31: 37,
  statusDeviceFaultsSystemRestarted: 38,

  modelTypeGroup: 100,
  modelTypeGroupAquatek: 101,
  modelTypeGroupTheralink: 102,
  modelTypeGroupOasis: 103,
  modelTypeGroupPoolTek: 104,
  modelTypeGroupHenden: 105,
  modelTypeGroupAqualight: 106,
  modelTypeGroupSummerTime: 107,
  modelTypeGroupSWC: 108,
  versionGroup: 90,
  versionUnknown: 91,
  version115B14: 92,
  //version115B15: 93,
  // version115B82: 94,
  version116B01: 93,
  version116B02: 94,
  versionBeta: 95,
};

export const statusItems = {
  all: 0,
  offline: 1,
  fault: 2,
  good: 3,
};

export const orpPhValues = {
  orp: 0,
  ph: 1,
};

export const spaModeStates = ['Pool Mode', 'Spa Mode'];

export const faults_bit_t = {
  FAULT_INTERNAL_COMMS_BIT: 0x0001,
  FAULT_THERMISTOR_1_SHORT_BIT: 0x0002,
  FAULT_THERMISTOR_1_OPEN_BIT: 0x0004,
  FAULT_THERMISTOR_2_SHORT_BIT: 0x0008,
  FAULT_THERMISTOR_2_OPEN_BIT: 0x0010,
  FAULT_PUMP_COMMS_FAULT_BIT: 0x0020,
  FAULT_SLAVE1_COMMS_FAULT_BIT: 0x0040,
  FAULT_SLAVE2_COMMS_FAULT_BIT: 0x0080,
  FAULT_AMBIENT_TEMPERATURE_BIT: 0x00000100,
  FAULT_SLAVE3_COMMS_FAULT_BIT: 0x00000200,
  FAULT_THERMISTOR_3_SHORT_BIT: 0x00000400,
  FAULT_THERMISTOR_3_OPEN_BIT: 0x00000800,
  FAULT_SMART_HEATER_FAULT: 0x00001000,
  FAULT_CRC_FAULT: 0x00002000,
  FAULT_CRC_2_FAULT: 0x00004000,
  FAULT_UPGRADE_IN_PROGRESS: 0x40000000,
  FAULT_SYSTEM_RESTART_BIT: 0x80000000,
};

export const faultTable = [
  {
    value: faults_bit_t.FAULT_INTERNAL_COMMS_BIT,
    label: 'Internal Comms Issue',
    short_label: 'Int Comms Issue',
    colour: COLOURS.faultsList[0],
  },
  {
    value: faults_bit_t.FAULT_THERMISTOR_1_SHORT_BIT,
    label: 'Thermistor 1 Short Circuit',
    short_label: 'Therm 1 S/C',
    colour: COLOURS.faultsList[1],
  },
  {
    value: faults_bit_t.FAULT_THERMISTOR_1_OPEN_BIT,
    label: 'Thermistor 1 Open Circuit',
    short_label: 'Therm 1 O/C',
    colour: COLOURS.faultsList[2],
  },
  {
    value: faults_bit_t.FAULT_THERMISTOR_2_SHORT_BIT,
    label: 'Thermistor 2 Short Circuit',
    short_label: 'Therm 2 S/C',
    colour: COLOURS.faultsList[3],
  },
  {
    value: faults_bit_t.FAULT_THERMISTOR_2_OPEN_BIT,
    label: 'Thermistor 2 Open Circuit',
    short_label: 'Therm 2 O/C',
    colour: COLOURS.faultsList[4],
  },
  {
    value: faults_bit_t.FAULT_PUMP_COMMS_FAULT_BIT,
    label: 'Pump Communications Fault',
    short_label: 'Pump Fault',
    colour: COLOURS.faultsList[5],
  },
  {
    value: faults_bit_t.FAULT_SLAVE1_COMMS_FAULT_BIT,
    label: 'Expansion 1 Fault',
    short_label: 'Exp 1 Fault',
    colour: COLOURS.faultsList[6],
  },
  {
    value: faults_bit_t.FAULT_SLAVE2_COMMS_FAULT_BIT,
    label: 'Expansion 2 Fault',
    short_label: 'Exp 2 Fault',
    colour: COLOURS.faultsList[7],
  },
  {
    value: faults_bit_t.FAULT_AMBIENT_TEMPERATURE_BIT,
    label: 'Ambient Temperature Fault',
    short_label: 'Amb Temp Fault',
    colour: COLOURS.faultsList[8],
  },
  {
    value: faults_bit_t.FAULT_SLAVE3_COMMS_FAULT_BIT,
    label: 'pH/ORP Expansion Fault',
    short_label: 'pH/ORP Exp Flt',
    colour: COLOURS.faultsList[9],
  },
  {
    value: faults_bit_t.FAULT_THERMISTOR_3_SHORT_BIT,
    label: 'Thermistor 3 Short Circuit',
    short_label: 'Therm 3 S/C',
    colour: COLOURS.faultsList[10],
  },
  {
    value: faults_bit_t.FAULT_THERMISTOR_3_OPEN_BIT,
    label: 'Thermistor 3 Open Circuit',
    short_label: 'Therm3 O/C',
    colour: COLOURS.faultsList[11],
  },
  {
    value: faults_bit_t.FAULT_SMART_HEATER_FAULT,
    label: 'Smart Heater Fault',
    short_label: 'SH Fault',
    colour: COLOURS.faultsList[12],
  },
  {
    value: faults_bit_t.FAULT_CRC_FAULT,
    label: 'Sys Config Reset',
    short_label: 'SysCon Fltg',
    colour: COLOURS.faultsList[13],
  },
  {
    value: faults_bit_t.FAULT_CRC_2_FAULT,
    label: 'Sec Config Reset',
    short_label: 'SECCon Fltg',
    colour: COLOURS.faultsList[14],
  },
  {
    value: faults_bit_t.FAULT_UPGRADE_IN_PROGRESS,
    label: 'Firmware Upgrade In Progress',
    short_label: 'Upg In Prog',
    colour: COLOURS.faultsList[15],
  },
  {
    value: faults_bit_t.FAULT_SYSTEM_RESTART_BIT,
    label: 'System Restarted',
    short_label: 'Sys Restart',
    colour: COLOURS.faultsList[16],
  },
];

export const wifiStatusBit_t = {
  ONLINE_BIT: 0x0001,
  AWS_BIT: 0x0002,
  SMARTCONFIG_BIT: 0x0004,
  PASSWORD_INCORRECT_BIT: 0x0008,
  WIFIMANAGER_BIT: 0x0010,
  VALID_BIT: 0x8000,
};

export const wifiStatusTable = [
  { value: wifiStatusBit_t.ONLINE_BIT, label: 'Online', colour: COLOURS.faultsList[0] },
  { value: wifiStatusBit_t.AWS_BIT, label: 'AWS', colour: COLOURS.faultsList[1] },
  { value: wifiStatusBit_t.SMARTCONFIG_BIT, label: 'Smart Config', colour: COLOURS.faultsList[2] },
  { value: wifiStatusBit_t.PASSWORD_INCORRECT_BIT, label: 'Password Incorrect', colour: COLOURS.faultsList[3] },
  { value: wifiStatusBit_t.WIFIMANAGER_BIT, label: 'Wifi Manager', colour: COLOURS.faultsList[4] },
  { value: wifiStatusBit_t.VALID_BIT, label: 'Valid', colour: COLOURS.faultsList[5] },
];

export const outputs_bit_t = {
  OP_APP_1: 0x0001,
  OP_APP_2: 0x0002,
  OP_VLV1: 0x0004,
  OP_VLV2: 0x0008,
  OP_VLV3: 0x0010,
  OP_VLV4: 0x0020,
  OP_HEATER: 0x0040,
  OP_RS485: 0x0080,

  OP_MOTOR_GND: 0x0100,
  OP_SPEED_1: 0x0200,
  OP_SPEED_2: 0x0400,
  OP_SPEED_3: 0x0800,
  OP_SPEED_4: 0x1000,
};

export const outputsTable = [
  { value: outputs_bit_t.OP_APP_1, label: 'Appliance 1', short_label: 'Skt 1', colour: COLOURS.faultsList[0] },
  { value: outputs_bit_t.OP_APP_2, label: 'Appliance 2', short_label: 'Skt 2', colour: COLOURS.faultsList[1] },
  { value: outputs_bit_t.OP_VLV1, label: 'Valve 1', short_label: 'Vlv 1', colour: COLOURS.faultsList[2] },
  { value: outputs_bit_t.OP_VLV2, label: 'Valve 2', short_label: 'Vlv 2', colour: COLOURS.faultsList[3] },
  { value: outputs_bit_t.OP_VLV3, label: 'Valve 3', short_label: 'Vlv 3', colour: COLOURS.faultsList[4] },
  { value: outputs_bit_t.OP_VLV4, label: 'Valve 4', short_label: 'Vlv 4', colour: COLOURS.faultsList[5] },
  { value: outputs_bit_t.OP_HEATER, label: 'HEATER', short_label: 'VF', colour: COLOURS.faultsList[6] },
  { value: outputs_bit_t.OP_RS485, label: 'RS485', short_label: 'RS485', colour: COLOURS.faultsList[7] },
  { value: outputs_bit_t.OP_MOTOR_GND, label: 'Motor Ground', short_label: 'Mot', colour: COLOURS.faultsList[8] },
  { value: outputs_bit_t.OP_SPEED_1, label: 'Speed 1', short_label: 'S1', colour: COLOURS.faultsList[9] },
  { value: outputs_bit_t.OP_SPEED_2, label: 'Speed 2', short_label: 'S2', colour: COLOURS.faultsList[10] },
  { value: outputs_bit_t.OP_SPEED_3, label: 'Speed 3', short_label: 'S3', colour: COLOURS.faultsList[11] },
  { value: outputs_bit_t.OP_SPEED_4, label: 'Speed 4', short_label: 'S4', colour: COLOURS.faultsList[12] },
];

export const sheaterStates = [
  { value: 0, label: 'Unknown' },
  { value: 1, label: 'Fault' },
  { value: 2, label: 'Start Requested' },
  { value: 3, label: 'Start Confirmed' },
  { value: 4, label: 'Stop Requested' },
  { value: 5, label: 'Stop Confirmed' },
];

export const sheaterFaults = [
  { value: 512, label: 'Inlet water temperature sensor failure PP01' },
  { value: 513, label: 'Outlet water temperature sensor failure PP02' },
  { value: 514, label: 'Overheating in heating mode EE04' },
  { value: 515, label: 'Gas exhaust too high protection EE05' },
  { value: 516, label: 'Low ambient temperature protection PP08' },
  { value: 517, label: 'Cooling pipe temperature too high protection PP10' },
  { value: 518, label: 'Low pressure protection EE02' },
  { value: 519, label: 'High pressure protection EE01' },
  { value: 520, label: 'Ambient temperature sensor failure PP05' },
  { value: 521, label: 'Water flow abnormal' },
  { value: 522, label: 'Grade 1 and Grade 2 antifreeze protection in winter PP07' },
  { value: 523, label: 'Software control failure EE21' },
  { value: 524, label: 'Protection for too cold when cooling PP11' },
  { value: 525, label: 'Heating coil temperature sensor failure PP03' },
  { value: 526, label: 'Gas return temperature sensor failure PP04' },
  { value: 527, label: 'Current detection circuit failure EE22' },

  { value: 528, label: 'PFC module protection EE16' },
  { value: 529, label: 'Exhaust temperature failure PP06' },
  { value: 530, label: 'Communication failure between mainboard and driving board EE09' },
  { value: 531, label: 'Controller EEPROM read and write failure EE06' },
  { value: 532, label: 'PFC module temperature sensing internal circuit failure EE18' },
  { value: 533, label: 'Module board failure EE11' },
  { value: 534, label: 'VDC voltage too high protection EE10' },
  { value: 535, label: 'Compressor current protection EE07' },
  { value: 536, label: 'DC fan motor 1 failure EE17' },
  { value: 537, label: 'PFC module high temperature protection EE19' },
  { value: 538, label: 'Input power failure EE20' },
  { value: 539, label: 'Communication failure between controller and mainboard EE08' },
  { value: 540, label: 'VDC voltage too low protection EE12' },
  { value: 541, label: 'Over current protection EE13' },
  { value: 542, label: 'Driving board ambient temperature bulb failure EE24' },
  { value: 543, label: 'IPM module temperature too high protection EE15' },

  { value: 768, label: 'E0' },
  { value: 769, label: 'E1 High pressure protection' },
  { value: 770, label: 'E2 Low pressure protection' },
  { value: 771, label: 'E3 No water protection' },
  { value: 772, label: 'E4 3 phase sequence protection (three phase only)' },
  { value: 773, label: 'E5 Power supply excess operation range' },
  {
    value: 774,
    label: 'E6 Excessive temp difference between inlet and outlet water (Insufficient water flow protection)',
  },
  { value: 775, label: 'E7 Water outlet temp too high or too low protection' },
  { value: 776, label: 'E8 High exhaust temp protection' },
  { value: 777, label: 'E9' },
  { value: 778, label: 'EA Evaporator overheat protection (only at cooling mode)' },
  { value: 779, label: 'Eb Ambient temperature too high or too low protection' },
  { value: 781, label: 'Ed Anti-freezing reminder' },

  { value: 784, label: 'P0 Controller communication failure' },
  { value: 785, label: 'P1 Water inlet temp sensor failure' },
  { value: 786, label: 'P2 Water outlet temp sensor failure' },
  { value: 787, label: 'P3 Gas exhaust temp sensor failure' },
  { value: 788, label: 'P4 Evaporator coil pipe temp sensor failure' },
  { value: 789, label: 'P5 Gas return temp sensor failure' },
  { value: 790, label: 'P6 Cooling coil pipe temp sensor failure' },
  { value: 791, label: 'P7 Ambient temp sensor failure' },
  { value: 792, label: 'P8 Cooling plate sensor failure' },
  { value: 793, label: 'P9 Current sensor failure' },
  { value: 794, label: 'PA Restart memory failure' },

  { value: 800, label: 'F0' },
  { value: 801, label: 'F1 Compressor drive module failure' },
  { value: 802, label: 'F2 PFC module failure' },
  { value: 803, label: 'F3 Compressor start failure' },
  { value: 804, label: 'F4 Compressor running failure' },
  { value: 805, label: 'F5 Inverter board over current protection' },
  { value: 806, label: 'F6 Inverter board overheat protection' },
  { value: 807, label: 'F7 Current protection' },
  { value: 808, label: 'F8 Cooling plate overheat protection' },
  { value: 809, label: 'F9 Fan motor failure' },
  { value: 810, label: 'FA PFC module over current protection (reserved)' },
  { value: 811, label: 'Fb Power filter plate No-power protection' },

  { value: 1024, label: 'Inlet water temperature failure P01' },
  { value: 1025, label: 'Water outlet temperature failure P02' },
  { value: 1026, label: 'Ambient temperature failure P04' },
  { value: 1027, label: 'Coil temperature failure P05' },
  { value: 1028, label: 'Suction temperature failure P07' },
  { value: 1029, label: 'Discharge temperature failure P081' },
  { value: 1030, label: 'Compressor Over Current Protection E051' },
  { value: 1031, label: 'High pressure protection E01' },
  { value: 1032, label: 'Low pressure protection E02' },
  { value: 1033, label: 'Water flow failure E03' },
  { value: 1034, label: 'Primary winter antifreeze protection E19' },
  { value: 1035, label: 'Secondary winter antifreeze protection E29' },
  { value: 1036, label: 'Antifreeze protection E07' },
  { value: 1037, label: 'High discharge temperature protection of  system 1 ' },
  { value: 1038, label: 'Too big difference between inlet and outlet water temperature E06' },
  { value: 1039, label: 'Defrosting' },

  { value: 1040, label: 'Compressor overload protection more than 3 times' },
  { value: 1041, label: 'High pressure protection more than 3 times' },
  { value: 1042, label: 'Low pressure protection more than 3 times' },
  { value: 1043, label: 'Water flow protection more than 3 times' },
  { value: 1044, label: 'Antifreezing protection more than 3 times' },
  { value: 1045, label: 'High discharge temperature protection more than 3 times' },
  { value: 1046, label: 'MOP Drive Warning F01' },
  { value: 1047, label: 'Converter Board Off-line F02' },
  { value: 1048, label: 'IPM Protection F03' },
  { value: 1049, label: 'Compressor Start-up Failure F04' },
  { value: 1050, label: 'Converter Input Lost Phase F17' },
  { value: 1051, label: 'IPM Sampling Current Failure F18' },
  { value: 1052, label: 'Converter Overheat Protection F20' },
  { value: 1053, label: 'Converter DC Over Voltage F07' },
  { value: 1054, label: 'Converter DC Under Voltage F08' },
  { value: 1055, label: 'Input under voltage' },

  { value: 1056, label: 'Input over voltage ' },
  { value: 1057, label: 'Sampling voltage failure' },
  { value: 1058, label: 'DSP and PFC Connection Failure F12' },
  { value: 1059, label: 'Radiator Temperature Sensing Failure F19' },
  { value: 1060, label: 'V15V Over/Under Voltage Failure F28' },
  { value: 1061, label: 'PFC Failure F27' },
  { value: 1062, label: 'IPM Overheat Protection F15' },
  { value: 1063, label: 'Weak-magnetic Protection F16' },
  { value: 1064, label: 'Input Over Current Warning F24' },
  { value: 1065, label: 'Converter Overheat Warning F22' },
  { value: 1066, label: 'Input overcurrent protection' },
  { value: 1067, label: 'EEPROM Error Warning F25' },
  { value: 1068, label: 'IPM protection' },
  { value: 1069, label: 'DC fan motor driver board protection' },
  { value: 1070, label: 'Pressure sensor failure PP' },
  { value: 1071, label: 'Input Over Current F26' },

  { value: 1072, label: 'Antifreezing protection' },
  { value: 1073, label: 'Antifreezing protection in heating mode' },
  { value: 1074, label: 'EC fan motor feedback signal failure' },
  { value: 1075, label: 'fan motor 1 failure' },
  { value: 1076, label: 'fan motor 2 failure' },
  { value: 1077, label: 'DC fan motor communication failure' },

  { value: 1280, label: 'Probe 01 Alarm - Alarm status Trigger' },
  { value: 1281, label: 'Probe 02 Alarm - Alarm status Trigger' },
  { value: 1282, label: 'Probe 03 Alarm - Alarm status Trigger' },
  { value: 1283, label: 'Probe 04 Alarm - Alarm status Trigger' },
  { value: 1284, label: 'Probe 05 Alarm - Alarm status Trigger' },
  { value: 1285, label: 'Probe 06 Alarm - Alarm status Trigger' },
  { value: 1286, label: 'Probe 07 Alarm - Alarm status Trigger' },
  { value: 1287, label: 'Probe 08 Alarm - Alarm status Trigger' },
  { value: 1288, label: 'Probe 09 Alarm - Alarm status Trigger' },
  { value: 1289, label: 'Probe 10 Alarm - Alarm status Trigger' },
  { value: 1290, label: 'Probe 11 Alarm - Alarm status Trigger' },
  { value: 1291, label: 'Probe 12 Alarm - Alarm status Trigger' },
  { value: 1292, label: 'Alarm Comp 1' },
  { value: 1293, label: 'Alarm Comp 2' },
  { value: 1294, label: 'Alarm Comp 3' },
  { value: 1295, label: 'Alarm Comp 4' },
  { value: 1296, label: 'Alarm Comp 5' },
  { value: 1297, label: 'Alarm Comp 6' },
  { value: 1298, label: 'Compressor 1 O/L' },
  { value: 1299, label: 'Compressor 2 O/L' },
  { value: 1300, label: 'Compressor 3 O/L' },
  { value: 1301, label: 'Compressor 4 O/L' },
  { value: 1302, label: 'Compressor 5 O/L' },
  { value: 1303, label: 'Compressor 6 O/L' },
  { value: 1304, label: 'Temperature Delta Alarm 1 (Hot side)' },
  { value: 1305, label: 'Temperature Delta Alarm 2 (Hot side)' },
  { value: 1306, label: 'Temperature Delta Alarm 3 (Hot side)' },
  { value: 1307, label: 'Temperature Delta Alarm 4 (Hot side)' },
  { value: 1308, label: 'Temperature Delta Alarm 5 (Hot side)' },
  { value: 1309, label: 'Temperature Delta Alarm 6 (Hot side)' },
  { value: 1310, label: 'Temperature Delta Alarm 1 (Cool side)' },
  { value: 1311, label: 'Temperature Delta Alarm 2 (Cool side)' },
  { value: 1312, label: 'Temperature Delta Alarm 3 (Cool side)' },
  { value: 1313, label: 'Temperature Delta Alarm 4 (Cool side)' },
  { value: 1314, label: 'Temperature Delta Alarm 5 (Cool side)' },
  { value: 1315, label: 'Temperature Delta Alarm 6 (Cool side)' },
  { value: 1316, label: 'High Leaving Water Temperature Alarm' },

  { value: 65533, label: 'BAD INTERFACE' },
  { value: 65534, label: 'BUFFER TOO SMALL' },
  { value: 65535, label: 'NO ERROR' },
];

export const phLevelsLookup = [
  { value: 0, label: 'none' },
  { value: 1, label: 'pH low' },
  { value: 2, label: 'pH High' },
  { value: 3, label: 'pH Good' },
];

// 0xFFB1 / 0xFFB2 — these two addresses were repurposed by firmware. They are
// action registers, not per-expansion config: writing 255 triggers the action and
// the register reports progress back. Values are firmware's own.
export const resetExpansionsLookup = [
  { value: 0, label: 'Idle' },
  { value: 255, label: 'Reset All' },
];

export const scanExpansionsLookup = [
  { value: 0, label: 'Idle' },
  { value: 1, label: 'Searching' },
  { value: 255, label: 'Scan' },
];

// 0x00BB "Spa On From" — what put the spa into spa mode. The values are
// firmware's own definitions, and are an enumeration rather than a bitmask or a
// duration: this register was previously read as a raw number titled
// "SPA Timer".
export const spaOnFromLookup = [
  { value: 0, label: '---' },
  { value: 34, label: 'Timer' },
  { value: 51, label: 'Pump Call' },
];

export const loggingEnabledLookup = [
  { value: 0, label: 'Disabled' },
  { value: 1, label: 'Enabled' },

  { value: 0xad, label: 'Disabled (new)' },
  { value: 0xba, label: 'Enabled (new)' },
];

export const orpLevelsLookup = [
  { value: 0, label: 'none' },
  { value: 1, label: 'ORP low' },
  { value: 2, label: 'ORP High' },
  { value: 3, label: 'ORP Good' },
];

export const autoChlorStates = [
  { value: 0, label: 'INIT' },
  { value: 1, label: 'TEST SENSORS' },
  { value: 2, label: 'IDLE' },
  { value: 3, label: 'WAIT' },
  { value: 4, label: 'CHECK LEVEL' },
  { value: 5, label: 'TAKING READING' },
  { value: 6, label: 'SETTLE' },
  { value: 7, label: 'REGULATING' },
  { value: 8, label: 'REGULATING WAITING' },
  { value: 9, label: 'STOP' },
  { value: 10, label: 'LIMIT' },
  { value: 11, label: 'OUTSIDE TIMERS' },
]; //!< list of the states for the auto chlorinator
